// src/constants/colors.js

/**
 * Brand color palette - References CSS custom properties defined in index.css
 * This ensures a single source of truth (CSS) while allowing JavaScript access
 *
 * Only 1 base color is customizable via Firestore (primary).
 * All other brand colors are computed automatically from the primary color:
 * - primaryHover: lightened by 15%
 * - accentOverlay: 18% opacity
 * - buttonLight: darkened by 70%
 * - buttonLightHover: lightened by 15%
 * - surfaceTint: constant (#f8fafc) - not customizable
 *
 * To use in JS/React components:
 * import { BRAND_COLORS } from './constants/colors';
 * <div style={{ color: BRAND_COLORS.primary }}>Primary color text</div>
 * <button style={{ backgroundColor: BRAND_COLORS.buttonLight }}>Button</button>
 */
export const BRAND_COLORS = {
  // Primary brand color - Base color (customizable)
  primary: 'var(--brand-primary)',                 // Base: #7c3aed (stored in Firestore)
  primaryHover: 'var(--brand-primary-hover)',      // Computed: lightened by 15%
  accentOverlay: 'var(--brand-accent-overlay)',    // Computed: 18% opacity overlay

  // Light mode button color - Computed from primary
  buttonLight: 'var(--brand-button-light)',        // Computed: darkened by 70%
  buttonLightHover: 'var(--brand-button-light-hover)', // Computed: lightened by 15%

  // Surface tint - Constant (not customizable)
  surfaceTint: 'var(--brand-surface-tint)',        // Constant: #f8fafc
};

// Semantic color references (for backward compatibility)
export const COLORS = {
  primary: 'var(--color-accent)',
  primaryLight: 'var(--color-accent-hover)',
  textGray: 'var(--color-text-secondary)',
  lightBackground: 'var(--color-surface-muted)',
  brandPurple: BRAND_COLORS.primary,
};
